import React, { useEffect, useState } from 'react';
import { getDevice } from '../../components/Service/UserService';
import { Table, Pagination, Form } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import useLanguage from '../../Hooks/useLanguage';
import LoadingSpinner from '../../css/Loading';
function Device() {
    const [device, setDevice] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const { t, i18n } = useTranslation();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const language = localStorage.getItem('language') || 'en';
        i18n.changeLanguage(language);
    }, [i18n]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getDevice();
                const sortedData = response?.userlog?.sort((a, b) => b.id - a.id) || [];
                setDevice(sortedData);

            } catch (error) {
            }
            setLoading(false);
        };

        fetchData();
    }, []);

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = device.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(device.length / itemsPerPage);

    const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);
    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1);
    };
    if (loading) {
        return (
            <LoadingSpinner></LoadingSpinner>
        );
    }

    return (
        <div
            className="container mt-4"
        // style={{
        //     display: 'flex',
        //     flexDirection: 'column',
        //     height: '100vh', 
        // }}
        >
            <h3 className="text-center mb-4" style={{ color: "#007bff" }}>Device User Log</h3>

            <div className="d-flex justify-content-between mb-3">
                <div>
                    <span>{`Showing ${indexOfFirstItem + 1} to ${Math.min(indexOfLastItem, device.length)} of ${device.length} records found`}</span>
                </div>
                <div className="d-flex align-items-center">
                    <span style={{ marginRight: "8px" }}>{t("Showing")}</span>
                    <Form.Select
                        value={itemsPerPage}
                        onChange={handleItemsPerPageChange}
                        style={{ width: '150px' }}
                    >
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </Form.Select>
                </div>
            </div>

            <div
                className="table-responsive"
            // style={{
            //     flex: 1, 
            //     overflowY: 'auto', 
            // }}
            >
                <Table bordered hover className="table-custom">
                    <thead className="table-primary text-center">
                        <tr>
                            <th>#</th>
                            <th>{t("IP address")}</th>
                            <th>{t("Browser")}</th>
                            <th>{t("Operating System")}</th>
                            <th>{t("Time")}</th>
                            <th>{t("Action")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {currentItems.length > 0 ? (
                            currentItems.map((item, index) => (
                                <tr key={index} className="text-center">
                                    <td>{indexOfFirstItem + index + 1}</td>
                                    <td>{item.ip_address || 'N/A'}</td>
                                    <td>{item.browser || 'N/A'}</td>
                                    <td>{item.platform || 'N/A'}</td>
                                    <td>
                                        {new Date(item?.created_at).toLocaleString('vi-VN', {
                                            weekday: 'short',
                                            year: 'numeric',
                                            month: 'short',
                                            day: 'numeric',
                                            hour: '2-digit',
                                            minute: '2-digit',
                                        })}
                                    </td>
                                    <td>{item?.action || 'login'}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="6" className="text-center">Không có dữ liệu</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </div>

            <div
                className="d-flex justify-content-center mt-4"
            // style={{
            //     position: 'sticky',
            //     bottom: '0', 
            //     backgroundColor: 'white',
            //     zIndex: 1000,
            //     display: 'flex',
            //     justifyContent: 'center',
            //     padding: '10px 0',
            //     boxShadow: '0 -2px 5px rgba(0, 0, 0, 0.1)',
            // }}
            >
                <Pagination>
                    <Pagination.Prev
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        {t("Previous")}
                    </Pagination.Prev>

                    {[...Array(totalPages)].map((_, i) => (
                        <Pagination.Item
                            key={i + 1}
                            active={i + 1 === currentPage}
                            onClick={() => handlePageChange(i + 1)}
                        >
                            {i + 1}
                        </Pagination.Item>
                    ))}

                    <Pagination.Next
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        {t("Next")}

                    </Pagination.Next>
                </Pagination>
            </div>
        </div>
    );
}

export default Device;
